import React from 'react';
import { Table, Skeleton, Group, Stack } from '@good/ui/core';

interface BookingsTableSkeletonProps {
  rows?: number;
}

export const BookingsTableSkeleton = ({ rows = 20 }: BookingsTableSkeletonProps) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <Table.Tr key={index}>
          <Table.Td w={30}>
            <Group>
              <Skeleton h={18} w={18} />
            </Group>
          </Table.Td>
          <Table.Td>
            <Skeleton h={20} w={20} radius='50%' />
          </Table.Td>
          <Table.Td>
            <Stack gap={6}>
              <Skeleton w='70%' h={18} />
              <Skeleton w='100%' h={18} />
            </Stack>
          </Table.Td>
          <Table.Td>
            <Group wrap='nowrap'>
              <Skeleton h={32} w={32} miw={32} radius='50%' />
              <Skeleton h={18} maw='50%' />
            </Group>
          </Table.Td>
          <Table.Td>
            <Stack gap={6}>
              <Skeleton w='70%' h={18} />
              <Skeleton w='30%' h={18} />
            </Stack>
          </Table.Td>
          <Table.Td>
            <Group wrap='nowrap'>
              <Skeleton h={32} w={32} miw={32} radius='md' />
              <Skeleton h={18} maw='50%' />
            </Group>
          </Table.Td>
          <Table.Td>
            <Skeleton w='100%' h={18} />
          </Table.Td>
          <Table.Td>
            <Skeleton h={20} w={20} radius='50%' />
          </Table.Td>
          <Table.Td>
            <Skeleton h={20} w={20} radius='50%' />
          </Table.Td>
        </Table.Tr>
      ))}
    </>
  );
};
